const ManageCookies = require('./../../../shared/scripts/cookieManagement');
const VAL_ALERTDRAWERCOOKIE_NAME = "ValAlert";
const VAL_ALERTDRAWERCOOKIE_DAYSTOLIVE = 30;

$(function () {

    if (!$('header').length) return;

    let $navTopDrawer = $('#nav-top-drawer');
    let $navSecondary = $('#nav-primary');
    let $navPrimary = $('#nav-primary');
    let $navBottomDrawer = $('#nav-bottom-drawer');
    let drawerToShow = $('#drawerToShow').val();
    let alertId = $('#alertId').val();
    
    //To hide/show submenu
    $('#nav-primary a').on('click',function(){
        let isnotopened=true;
        if($(this).attr('aria-expanded')=='true'){
            isnotopened=false;
        }
        $('#nav-primary a').addClass('collapsed').attr('aria-expanded',false);        
        $('#nav-bottom-drawer .navbar-collapse').addClass('hidden');
       if(isnotopened){
        $(this).removeClass('collapsed').attr('aria-expanded',true); 
        $($(this).attr('dest')).removeClass('hidden');
       }
    });
    $('#main-container').on('click',function(){
        $('#nav-primary a').trigger('click');
    });
    //Try to show a drawer on page load
    showDrawerOnPageLoad($navTopDrawer, drawerToShow, alertId);

    //Accordion-like functionality, customize default transitions based on state
    $navTopDrawer.on('show.bs.collapse', '.collapse', (e) => {
        drawer_Show($navTopDrawer, e.target.id);
        drawer_showCollapseTriggerTopBorder(e.target.id);
    });
    $navTopDrawer.on('shown.bs.collapse', '.collapse', (e) => drawer_Shown($navTopDrawer));
    $navTopDrawer.on('hide.bs.collapse', '.collapse', (e) => drawer_hideCollapseTriggerTopBorder(e.target.id));

    $navBottomDrawer.on('show.bs.collapse', '.collapse', (e) => drawer_Show($navBottomDrawer, this.id));
    $navBottomDrawer.on('shown.bs.collapse', '.collapse', (e) => drawer_Shown($navBottomDrawer));

    $navTopDrawer.on('click', '.close-top-drawer', function () {
        let $openSection = $navTopDrawer.find('.collapse.in');
        $openSection.collapse('hide');
    });

    $('#main-container').on('scroll', function () {
        let $openSection = $navBottomDrawer.find('.collapse.in');
        $openSection.collapse('hide');
    });

    $('.subnavigation-container.with-children .parent').on('click', '.subnavigation-link[data-child]', function (e) {
        let $this = $(this),
            $parent = $this.parent(),
            $child = $('#' + $this.data('child'));

        //fade this out
        $parent.addClass('parent-hidden');

        //fade in child
        $child.addClass('child-visible')

    });

    $('.subnavigation-container.with-children .child').on('click', '.back.subnavigation-link', function (e) {
        let $this = $(this),
            $parent = $('.subnavigation-container.with-children .parent'),
            $child = $this.parent();

        //fade this out
        $child.removeClass('child-visible');

        //fade in parent
        $parent.removeClass('parent-hidden');

    });

    $('#navbar-collapse-valimportantmessage #btn-dismiss-valimportantmessage').on('click', function () {
        if (alertId) {
            persistAlertDismissal(alertId);
        }
    });

    let windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
    let mobile = windowWidth < 500;
    if(mobile){
        let moveElement=$("#navbar-collapse-winningnumbers-link").parent();
        $("#header-top-row-live-drawing").addClass('b-blue').addClass('with-border');
        $("#header-top-row-live-drawing").insertAfter(moveElement);
        $('.spacebreak').each(function(){
            try{
                let formattedHtml=$(this).html().replace(' ','<br>');
                $(this).html(formattedHtml);            
            }catch(err){
                console.error('splitting for break ('+$(this).html()+')error- '+err.message);
            }
        }); 
}else{
    let moveElement=$("#wp-welcome-message");
    $("#header-top-row-live-drawing").removeClass('b-blue').removeClass('with-border');
    $("#header-top-row-live-drawing").insertAfter(moveElement);
}    
});

function drawer_Show($headerDrawer, sectionId) {
    let $openSection = $headerDrawer.find('.collapse.in');

    if (sectionId !== $openSection.attr('id') && $openSection.length) {
        $headerDrawer.find('.collapse').addClass('stop-transition');
    }

    $openSection.collapse('hide');
    drawer_ShowParent($headerDrawer);
}
function drawer_Shown($headerDrawer) {
    $headerDrawer.find('.collapse').removeClass('stop-transition');
}

function drawer_ShowParent($headerDrawer) {
    let $parent = $headerDrawer.find('.parent');
    let $child = $headerDrawer.find('.child');

    $parent.removeClass('parent-hidden');
    $child.removeClass('child-visible');
}

function drawer_showCollapseTriggerTopBorder(sectionId) {
    let selector = `a[data-target='#${sectionId}']`;
    let $thisTogglesDrawer = $('#nav-secondary').find(`a[data-target='#${sectionId}']`);

    $thisTogglesDrawer.parent('.nav-item').addClass('controls-active-drawer');
}
function drawer_hideCollapseTriggerTopBorder(sectionId) {
    let selector = `a[data-target='#${sectionId}']`;
    let $thisTogglesDrawer = $('#nav-secondary').find(`a[data-target='#${sectionId}']`);

    $thisTogglesDrawer.parent('.nav-item').removeClass('controls-active-drawer');
}

function showDrawerOnPageLoad($navTopDrawer, drawerToShow, alertId) {

	console.log(drawerToShow);
    //If no drawer to show, escape
    if (!drawerToShow) return;

    //var shouldShowDrawerOnPageLoad = true;

    //Handle alert drawer functionality
    //if (drawerToShow.toUpperCase() === "ALERT" && alertId) {
    //    shouldShowDrawerOnPageLoad = checkPersistedAlertDismissal(alertId);
    //}

    //if (!shouldShowDrawerOnPageLoad) return;

    let $drawerToShow = $navTopDrawer.find(`[data-drawer-name="${drawerToShow}"]`);
	
    $drawerToShow.collapse('show');
}

function checkPersistedAlertDismissal(alertId) {
    let cookieAlertId = ManageCookies.read(VAL_ALERTDRAWERCOOKIE_NAME);

    if (cookieAlertId) {
        //IF matching cookie value AND it matches alertID, user has dismissed it. do not show alert drawer
        if (cookieAlertId === alertId) {
            return false;
        } else {
            //IF cookieAlertID and alertID DO NOT MATCH THEN remove a cookie that persists the dismissal of an old alert
            removePersistedAlertDismissal(alertId);
        }
    };

    return true;
}

function persistAlertDismissal(alertId) {
    ManageCookies.create(VAL_ALERTDRAWERCOOKIE_NAME, alertId, VAL_ALERTDRAWERCOOKIE_DAYSTOLIVE);
}

function removePersistedAlertDismissal(alertId) {
    ManageCookies.erase(VAL_ALERTDRAWERCOOKIE_NAME);
}
$(document).ready(function () {
    try{   
    $("#header-top-row-live-drawing").after($("#wp-welcome-message"));     
    let windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
    let mobile = windowWidth < 500;   
    if(mobile){ 
         $('#wp-login-link span a').html('Login / Register')
    }
    else{
        $('#wp-login-link span a').html('Login')
    }
    }
    catch(err){console.log(err.message);}
});


// WEBPACK FOOTER //
// ./shared/components/header2/header.js